(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pretty-portal-article-detail"] && !Shopify.designMode) return;
  try {
    
  const initArticleMediaCarousels = () => {
    document.querySelectorAll('[data-article-media-carousel]').forEach((carousel) => {
      if (carousel.dataset.articleMediaInitialized === 'true') return;

      const slides = Array.from(carousel.querySelectorAll('[data-article-media-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-article-media-dot]'));
      const prev = carousel.querySelector('[data-article-media-prev]');
      const next = carousel.querySelector('[data-article-media-next]');

      if (!slides.length) return;

      carousel.dataset.articleMediaInitialized = 'true';
      let activeIndex = 0;

      const updateSlider = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        carousel.dataset.activeIndex = String(activeIndex);

        slides.forEach((slide) => {
          const isActive = Number(slide.dataset.slideIndex) === activeIndex;
          slide.classList.toggle('is-active', isActive);

          slide.querySelectorAll('video').forEach((video) => {
            if (isActive) {
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            } else {
              video.pause();
            }
          });
        });

        dots.forEach((dot) => {
          const isActive = Number(dot.dataset.slideIndex) === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      updateSlider(0);
      if (prev && next) {
        prev.addEventListener('click', () => updateSlider(activeIndex - 1));
        next.addEventListener('click', () => updateSlider(activeIndex + 1));
      }
      dots.forEach((dot) => {
        dot.addEventListener('click', () => updateSlider(Number(dot.dataset.slideIndex || 0)));
      });
    });
  };

  const initArticleZoomDialogs = () => {
    document.querySelectorAll('.pp-article-detail').forEach((section) => {
      if (section.dataset.articleZoomInitialized === 'true') return;

      const dialog = section.querySelector('[data-article-zoom-dialog]');
      const image = section.querySelector('[data-article-zoom-image]');
      const loader = section.querySelector('[data-article-zoom-loader]');
      const close = section.querySelector('[data-article-zoom-close]');
      const prev = section.querySelector('[data-article-zoom-prev]');
      const next = section.querySelector('[data-article-zoom-next]');
      const thumbnails = section.querySelector('[data-article-zoom-thumbnails]');
      const triggers = Array.from(section.querySelectorAll('[data-article-zoom-trigger]'));

      if (!dialog || !image || !triggers.length) return;
      section.dataset.articleZoomInitialized = 'true';

      const zoomItems = triggers
        .map((trigger, index) => ({
          trigger,
          index,
          src: trigger.dataset.zoomSrc,
          thumb: trigger.dataset.zoomThumb || trigger.dataset.zoomSrc,
          alt: trigger.dataset.zoomAlt || '',
        }))
        .filter((item) => item.src);

      if (!zoomItems.length) return;

      let activeIndex = 0;
      let activeTrigger = null;
      let loadToken = 0;
      let isDragging = false;
      let dragStartX = 0;
      let dragStartY = 0;
      let dragDeltaX = 0;
      let didDrag = false;
      let suppressClick = false;
      let previousBodyOverflow = '';
      let previousHtmlOverflow = '';

      const lockBodyScroll = () => {
        previousBodyOverflow = document.body.style.overflow;
        previousHtmlOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      };

      const unlockBodyScroll = () => {
        document.documentElement.style.overflow = previousHtmlOverflow;
        document.body.style.overflow = previousBodyOverflow;
      };

      const updateZoomControls = () => {
        const hasMultipleItems = zoomItems.length > 1;
        dialog.classList.toggle('has-carousel', hasMultipleItems);
        if (prev) prev.hidden = !hasMultipleItems;
        if (next) next.hidden = !hasMultipleItems;
        if (thumbnails) thumbnails.hidden = !hasMultipleItems;

        if (!thumbnails) return;
        thumbnails.querySelectorAll('[data-article-zoom-thumbnail]').forEach((thumbnail) => {
          const isActive = Number(thumbnail.dataset.zoomIndex) === activeIndex;
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
          if (isActive) {
            thumbnail.scrollIntoView({ block: 'nearest', inline: 'center' });
          }
        });
      };

      const setLoading = (isLoading) => {
        dialog.classList.toggle('is-loading', isLoading);
        if (loader) loader.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
      };

      const showZoomItem = (nextIndex) => {
        activeIndex = (nextIndex + zoomItems.length) % zoomItems.length;
        const item = zoomItems[activeIndex];
        loadToken += 1;
        const currentLoadToken = loadToken;

        setLoading(true);
        dialog.setAttribute('aria-busy', 'true');
        image.classList.remove('is-loaded');
        image.alt = item.alt;
        image.src = item.src;
        updateZoomControls();

        const markLoaded = () => {
          if (currentLoadToken !== loadToken) return;
          setLoading(false);
          dialog.removeAttribute('aria-busy');
          image.classList.add('is-loaded');
        };

        if (typeof image.decode === 'function') {
          image.decode().then(markLoaded).catch(markLoaded);
        } else if (image.complete) {
          markLoaded();
        } else {
          image.addEventListener('load', markLoaded, { once: true });
          image.addEventListener('error', markLoaded, { once: true });
        }
      };

      const moveZoom = (direction) => {
        if (zoomItems.length <= 1) return;
        showZoomItem(activeIndex + direction);
      };

      const resetDrag = () => {
        isDragging = false;
        dragDeltaX = 0;
        image.style.transform = '';
        image.classList.remove('is-dragging');
      };

      const startDrag = (event) => {
        if (zoomItems.length <= 1) return;
        if (typeof event.button === 'number' && event.button !== 0) return;
        if (event.target instanceof Element && event.target.closest('button, a, [data-article-zoom-thumbnails]')) return;

        isDragging = true;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        dragDeltaX = 0;
        didDrag = false;
        image.classList.add('is-dragging');
        dialog.setPointerCapture?.(event.pointerId);
        event.preventDefault();
      };

      const drag = (event) => {
        if (!isDragging) return;

        dragDeltaX = event.clientX - dragStartX;
        const dragDeltaY = event.clientY - dragStartY;
        if (Math.abs(dragDeltaX) < Math.abs(dragDeltaY) * 0.7) return;

        if (Math.abs(dragDeltaX) > 6) {
          didDrag = true;
        }

        const dragOffset = Math.max(Math.min(dragDeltaX * 0.32, 110), -110);
        image.style.transform = `translateX(${dragOffset}px)`;
        event.preventDefault();
      };

      const endDrag = () => {
        if (!isDragging) return;

        const shouldMove = Math.abs(dragDeltaX) > Math.min(72, window.innerWidth * 0.12);
        const direction = dragDeltaX < 0 ? 1 : -1;
        const shouldSuppressClick = didDrag;
        resetDrag();

        if (shouldSuppressClick) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 0);
        }

        if (shouldMove) moveZoom(direction);
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          dialog.dispatchEvent(new Event('close'));
        }
      };

      if (thumbnails) {
        thumbnails.innerHTML = '';
        zoomItems.forEach((item) => {
          const thumbnail = document.createElement('button');
          thumbnail.type = 'button';
          thumbnail.className = 'pp-article-detail__zoom-thumbnail';
          thumbnail.dataset.articleZoomThumbnail = 'true';
          thumbnail.dataset.zoomIndex = String(item.index);
          const openImageLabel = thumbnails.dataset.openImageLabel || 'Open image [index]';
          const thumbnailAltLabel = thumbnails.dataset.thumbnailAltLabel || '[alt] thumbnail';
          const thumbnailFallbackAltLabel = thumbnails.dataset.thumbnailFallbackAltLabel || 'Image [index] thumbnail';
          thumbnail.setAttribute('aria-label', openImageLabel.replace('[index]', String(item.index + 1)));

          const thumbnailImage = document.createElement('img');
          thumbnailImage.src = item.thumb;
          thumbnailImage.alt = item.alt
            ? thumbnailAltLabel.replace('[alt]', item.alt)
            : thumbnailFallbackAltLabel.replace('[index]', String(item.index + 1));
          thumbnailImage.loading = 'lazy';
          thumbnailImage.decoding = 'async';

          thumbnail.append(thumbnailImage);
          thumbnail.addEventListener('click', () => showZoomItem(item.index));
          thumbnails.appendChild(thumbnail);
        });
      }

      updateZoomControls();

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const targetIndex = Number(trigger.dataset.zoomIndex || 0);
          activeTrigger = trigger;
          lockBodyScroll();
          if (typeof dialog.showModal === 'function') {
            try {
              dialog.showModal();
            } catch (_error) {
              dialog.setAttribute('open', '');
            }
          } else {
            dialog.setAttribute('open', '');
          }
          showZoomItem(targetIndex);
        });
      });

      close?.addEventListener('click', closeDialog);
      prev?.addEventListener('click', () => moveZoom(-1));
      next?.addEventListener('click', () => moveZoom(1));
      dialog.addEventListener('pointerdown', startDrag);
      dialog.addEventListener('pointermove', drag);
      dialog.addEventListener('pointerup', endDrag);
      dialog.addEventListener('pointercancel', resetDrag);
      dialog.addEventListener('lostpointercapture', endDrag);

      dialog.addEventListener('click', (event) => {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveZoom(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveZoom(1);
        }
      });

      dialog.addEventListener('close', () => {
        loadToken += 1;
        unlockBodyScroll();
        resetDrag();
        setLoading(false);
        dialog.removeAttribute('aria-busy');
        image.removeAttribute('src');
        image.alt = '';
        image.classList.remove('is-loaded');
        activeTrigger?.focus();
        activeTrigger = null;
      });
    });
  };

  initArticleMediaCarousels();
  initArticleZoomDialogs();
  document.addEventListener('shopify:section:load', initArticleMediaCarousels);
  document.addEventListener('shopify:section:load', initArticleZoomDialogs);

  } catch(e) { console.error(e); }
})();
})();
